import type { TFunction } from "i18next";
import { translateMetadataLabel } from "modules/record/shared/services/recordMetadataLabels";

// Catalog outputs carry a translation key (fluss.data.output.<group>.<key>) with the humanized key
// or the column label as default; record columns fall back to their (translatable) metadata label.
export const pickerOutputLabel = (t: TFunction, output: { label: string; labelKey?: string; key: string }): string => {
    const fallback = translateMetadataLabel(t, { label: output.label, name: output.key }) || output.key;
    return output.labelKey ? String(t(output.labelKey, { defaultValue: fallback })) : fallback;
};

